import logger from '@redbubble/next/logger';

export interface HandleOnCancelProps {
  onCancel: () => Promise<void>;
}

export const handleOnCancel = async ({ onCancel }: HandleOnCancelProps) => {
  // Refetching cart without the shipping address, as we only have the shipping country after the checkout flow is cancelled (and not the full address), so the tax values should be reset.
  // Passing 'undefined' below ensures the GetCart query is executed without any variables, and the /cart.json endpoint returns cart for user's preferred country.
  // If we used refreshCart() or refreshCart({}), Apollo would reuse the shipping address variables form the previous request.
  await onCancel().catch((error) => {
    const message = `Failed to refresh cart after user canceled Stripe Express checkout flow: ${error.message}`;
    logger.error(
      {
        err: error,
        context: 'Stripe/handlers/handleOnCancel',
        message,
      },
      message
    );
  });
};
